import ChatItem from '../ChatItem';
import styles from './styles.module.scss';
import { useEffect, useRef } from 'react';
import { useAppContext } from 'context/AppContext';
import { useScrollToTop } from 'hooks/useScrollToTop';
import { Vertical } from 'packages/radiant-react/layout';
import { getMessageRef, getIsLastUserMessage, getIsLastAiMessage } from 'utils/aiChat';

function ChatList() {
  const { chatMessages, isStreaming } = useAppContext();
  const containerRef = useRef<HTMLDivElement>(null);
  const { lastUserMsgRef, lastAiMsgRef } = useScrollToTop(
    containerRef,
    chatMessages.length,
    isStreaming
  );

  useEffect(() => {
    if (containerRef.current && !isStreaming) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, []);

  return (
    <Vertical className={styles['main-container']} ref={containerRef}>
      <Vertical className={styles['container']}>
        {chatMessages.map((message, index) => (
          <ChatItem
            key={message.id}
            message={message}
            isLastUserMessage={getIsLastUserMessage(index, chatMessages.length)}
            isLastAiMessage={getIsLastAiMessage(index, chatMessages.length)}
            itemRef={getMessageRef(index, chatMessages.length, lastUserMsgRef, lastAiMsgRef)}
          />
        ))}
      </Vertical>
    </Vertical>
  );
}

export default ChatList;
